//Courtesy of http://clrs.cc/ for however long this remains here
const niceColors = ['#1A3561', '#7AC143', '#E2581C', '#00B9F2', '#E01D97'];

export function getNiceColor(index: number) {
  return niceColors[index % niceColors.length];
}
